import type { BlobLike } from "@pdfking/compatibility"

export type BlobMap = Record<string, Promise<BlobLike>>
